export default class ProductCategoryList {
    constructor($el) {
        this.$el = $el;
        this.id = this.$el.dataset.productCategoryList;
        this.trigger = document.querySelector(`[data-product-category-list-trigger="${this.id}"]`);
        this.triggers = document.querySelectorAll(`[data-product-category-list-trigger]`);

        this.open = this.open.bind(this);
        this.closeAll = this.closeAll.bind(this);
        this.closeTriggers = this.closeTriggers.bind(this);

        if(this.trigger) {
            this.trigger.addEventListener('mouseover', this.open);
        }

        window.addEventListener('remove-category-list', this.closeAll);
    }

    open(e) {
        e.preventDefault();
        this.closeAll();
        this.$el.classList.add('product-category-list__child__content--open');
        this.closeTriggers();
        this.trigger.classList.add('product-category-list__link--active');
    }

    closeAll() {
        let all = document.querySelectorAll('[data-product-category-list]')
        all.forEach((item) => {
            item.classList.remove('product-category-list__child__content--open');
        })

        this.closeTriggers();
    }

    closeTriggers() {
        this.triggers.forEach((trigger) => {
            trigger.classList.remove('product-category-list__link--active');
        })
    }


}